import axios from '@/utils/request'

export function baseURL() {
  return process.env.NODE_ENV == 'production'
    ? 'https://dist.ssw-htzn.com'
    : 'https://dist-test.ssw-htzn.com'
}

export function getCategory() {
  return axios.get('/admin_api/v1/course/classify/full')
}

export function getCourse(params) {
  return axios.get('/admin_api/v1/course/product', { params })
}

export function uploadImg(data) {
  return axios.post('/admin_api/v1/common/image/upload/', data, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export function getTicketInfo(params) {
  return axios.get('/admin_api/v1/common/ticket/info/', { params })
}

export const uploadApi = `/admin_api/v1/common/image/upload/`
